import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  IoHomeOutline,
  IoHome,
  IoBriefcaseOutline,
  IoBriefcase,
  IoGridOutline,
  IoGrid,
  IoPersonOutline,
  IoPerson,
  IoDocumentTextOutline,
  IoDocumentText,
  IoMoonOutline,
  IoSunnyOutline,
  IoWaterOutline,
} from 'react-icons/io5'
import { MdOutlineComputer } from 'react-icons/md'
import './AquaHeader.css'

const navItems = [
  { to: '/', label: 'Home', Icon: IoHomeOutline, ActiveIcon: IoHome, end: true },
  {
    to: '/work',
    label: 'Experience',
    Icon: IoBriefcaseOutline,
    ActiveIcon: IoBriefcase,
  },
  {
    to: '/projects',
    label: 'Projects',
    Icon: IoGridOutline,
    ActiveIcon: IoGrid,
  },
  {
    to: '/about',
    label: 'About',
    Icon: IoPersonOutline,
    ActiveIcon: IoPerson,
  },
]

const resumeItem = {
  to: '/resume',
  label: 'Résumé',
  Icon: IoDocumentTextOutline,
  ActiveIcon: IoDocumentText,
}

const themeOptions = [
  { id: 'light', label: 'Light', Icon: IoSunnyOutline },
  { id: 'dark', label: 'Dark', Icon: IoMoonOutline },
  { id: 'system', label: 'System', Icon: MdOutlineComputer },
]

function AquaHeader({
  theme,
  setTheme,
  resolvedTheme,
  nextDesignLanguage,
  setDesignLanguage,
}) {
  const location = useLocation()
  const nextDesignName = nextDesignLanguage === 'material3' ? 'Canvas' : 'Aqua'
  const currentPath = location.pathname
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const onScroll = () => setIsActive(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const isCurrent = (item) =>
    item.end ? currentPath === item.to : currentPath.startsWith(item.to)

  return (
    <>
      <header
        className={`aqua-toolbar ${isActive ? 'is-scrolled' : ''}`}
        role="banner"
      >
        <div className="aqua-toolbar-shell">
          <Link to="/" className="aqua-brand" aria-label="Alan Pham, home">
            <img
              src="logo.png"
              alt=""
              width={28}
              height={28}
              className="aqua-logo aqua-logo-light"
            />
            <img
              src="logo-dark.png"
              alt=""
              width={28}
              height={28}
              className="aqua-logo aqua-logo-dark"
            />
            <span className="aqua-brand-name">Alan Pham</span>
          </Link>

          <nav className="aqua-nav" aria-label="Primary">
            {navItems.map((item) => {
              const active = isCurrent(item)
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`aqua-nav-link ${active ? 'active' : ''}`}
                  aria-current={active ? 'page' : undefined}
                >
                  {active ? <item.ActiveIcon /> : <item.Icon />}
                  <span>{item.label}</span>
                </Link>
              )
            })}
            <Link
              to={resumeItem.to}
              className={`aqua-nav-link ${isCurrent(resumeItem) ? 'active' : ''}`}
              aria-current={isCurrent(resumeItem) ? 'page' : undefined}
            >
              {isCurrent(resumeItem) ? (
                <resumeItem.ActiveIcon />
              ) : (
                <resumeItem.Icon />
              )}
              <span>{resumeItem.label}</span>
            </Link>
          </nav>

          <div className="aqua-controls">
            <div
              className="aqua-segmented"
              data-active-theme={theme}
              role="group"
              aria-label={`Color theme. Current: ${theme}${theme === 'system' ? `, following ${resolvedTheme}` : ''}.`}
            >
              {themeOptions.map(({ id, label, Icon }) => (
                <button
                  key={id}
                  type="button"
                  className={`aqua-segment ${theme === id ? 'active' : ''}`}
                  onClick={() => setTheme(id)}
                  aria-pressed={theme === id}
                  title={`Use ${label.toLowerCase()} appearance`}
                  aria-label={`Use ${label.toLowerCase()} appearance`}
                >
                  <Icon aria-hidden="true" />
                </button>
              ))}
            </div>
            <button
              type="button"
              className="aqua-design-toggle"
              onClick={() => setDesignLanguage(nextDesignLanguage)}
              title={`Switch to ${nextDesignName}`}
              aria-label={`Current theme: Aqua. Switch to ${nextDesignName}.`}
            >
              <IoWaterOutline aria-hidden="true" />
              <span className="aqua-design-toggle-label">Aqua</span>
            </button>
          </div>
        </div>
      </header>

      <nav className="aqua-tabbar" aria-label="Primary">
        <div className="aqua-tabbar-shell">
          {[...navItems, resumeItem].map((item) => {
            const active = isCurrent(item)
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`aqua-tab ${active ? 'active' : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                <span className="aqua-tab-icon">
                  {active ? <item.ActiveIcon /> : <item.Icon />}
                </span>
                <span className="aqua-tab-label">{item.label}</span>
              </Link>
            )
          })}
        </div>
      </nav>
    </>
  )
}

export default AquaHeader
